import React, { useEffect } from "react";
import { SidePanel } from "polotno/side-panel";
import { DEFAULT_SECTIONS } from "polotno/side-panel";
import CustomTextSection from "./CustomTextSection";
import CustomFontSection from "./CustomFontSection";
import { UploadPanel } from "./UploadPanel";
import { BackgroundPanel } from "./CustomBackground"; // ✅ Import correctly
import { GridSection } from "./GridSection";
import { reaction } from "mobx";
import { trackAnalyticsEvent } from "../../../utils/analytics";

const UploadSection = DEFAULT_SECTIONS.find(
  (section) => section.name === "upload"
);

UploadSection.Panel = UploadPanel;

// commenting background section for now
// const BackgroundSection = DEFAULT_SECTIONS.find((section) => section.name === "background");
// BackgroundSection.Panel = BackgroundPanel.Panel;

const sections = [
  // BackgroundSection, // ✅ Now correctly formatted
  UploadSection,
  CustomTextSection,
  CustomFontSection,
  // DEFAULT_SECTIONS.find((section) => section.name === "text"),
  DEFAULT_SECTIONS.find((section) => section.name === "elements"),
  GridSection,
  DEFAULT_SECTIONS.find((section) => section.name === "layers"),
  // DEFAULT_SECTIONS.find((section) => section.name === "size"),
].filter(Boolean);


const Sidebar = ({ store }) => {
  useEffect(() => {
    if (!store) {
      return undefined;
    }

    const dispose = reaction(
      () => store.openedSidePanel,
      (openedSection) => {
        if (!openedSection) {
          return;
        }

        trackAnalyticsEvent("design_sidebar_section_open", {
          section: openedSection,
        });
      }
    );

    return () => {
      dispose();
    };
  }, [store]);

  return <SidePanel store={store} sections={sections} />;
};

export default Sidebar;
